import { cn } from '@/lib/utils';
import { formatQuestionMarkdown } from '@/utils/formatQuestionMarkdown';

interface QuestionMarkdownProps {
  text: string | string[];
  className?: string;
}

/**
 * Renders interview question text as markdown via snarkdown, preserving the
 * deprecated `,, ` line-break format. See `formatQuestionMarkdown`.
 */
export function QuestionMarkdown({ text, className }: QuestionMarkdownProps) {
  return (
    <div
      className={cn('question-markdown', className)}
      dangerouslySetInnerHTML={{ __html: formatQuestionMarkdown(text) }}
    />
  );
}

export default QuestionMarkdown;
